export const pos_img_url = "https://image.tmdb.org/t/p/w342";
export const ph_img_url =
  "https://dummyimage.com/342x513/d9d9d9/382a63.png&text=No+Image";
